<template>
  <div>
    <div class="d-none d-md-block">
      <div class="row detalhe-procedimento">
        <div class="col-8">
          <div class="row mb-3">
            <div class="col-12">
              <h6 class="producao-procedimento-nome">
              {{`${procedimento.codigoProcedimento} - ${procedimento.descricaoProcedimento}`}}
              </h6>
            </div>
          </div>

          <div class="row producao-procedimento-detail">
            <div class="col">
              <span><strong>Seq:</strong></span>
              <span>{{sequencial}}</span>
            </div>
            <div class="col" v-show="procedimento.grau != null && procedimento.grau.length > 0">
              <span><strong>Grau:</strong></span>
              <span>{{procedimento.grau}}</span>
            </div>
            <div class="col">
              <span><strong>Quant:</strong></span>
              <span>{{procedimento.quantidade}}</span>
            </div>
            <div class="col">
              <span><strong>R$:</strong></span>
              <span>{{formatDecimalNumber(procedimento.valor, 2, ".", ",")}}</span>
            </div>
          </div>

        </div>

        <div class="col-4">
          <div class="row">
            <div class="col text-right">
              <button class="producao-procedimento-buttons producao-procedimento-button-delete"
                @click.stop="excluir(idProvisao, procedimento.codigoProcedimento)"
                :disabled="disableAproveProvisao">
                <div class="producao-procedimento-buttons-content">
                  <img src="/img/icons/excluir-vermelho.png" alt="" class="bt-icone">
                  <span>EXCLUIR</span>
                </div>
              </button>

              <button class="producao-procedimento-buttons producao-procedimento-button-ok"
                @click.stop="efetivar(idProvisao, procedimento.codigoProcedimento)"
                :disabled="loading.status || disableAproveProvisao">
                <div class="producao-procedimento-buttons-content">
                  <img src="/img/icons/excluir-azul.png" alt="" class="bt-icone">
                  <span>OK</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-12">
          <hr>
        </div>
      </div> -->

      <div v-if="procedimento.profissionaisExecutantes.length > 0" class="mb-3 mt-3 detalhe-equipe">
        <div class="row"
        v-for="(profissionalExecutante, index) in procedimento.profissionaisExecutantes"
        :key="index">
          <div class="col-8">
            <p class="mb-0">
              <b>{{ FuncaoDescricao(profissionalExecutante.grau) }}:</b>
              {{ profissionalExecutante.nome }}
            </p>
          </div>
          <div class="col-4 text-right">
            <p class="mb-0">
              <b>R$ {{ profissionalExecutante.valor | currency }}</b>
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <hr>
        </div>
      </div>

    </div>

    <div class="swipe-mobile">
      <div class="detalhe-procedimento">
        <swipe-list class="detalhe-procedimento-list" :items="swipeList"
        transition-key="id" ref="swipe" @swipeout:contentclick="contentClick">
          <template>
            <div class="detalhe-procedimento-content">
              <div class="detalhe-procedimento-content-mobile">
                <div class="row mb-3">
                  <div class="col-12">
                    <h6 class="producao-procedimento-nome">
                    {{`${procedimento.codigoProcedimento} - ${procedimento.descricaoProcedimento}`}}
                    </h6>
                  </div>
                </div>
                <div class="row producao-procedimento-detail">
                  <div class="col">
                    <span><strong>Seq:</strong></span> <br>
                    <span>{{sequencial}}</span>
                  </div>
                  <div
                  class="col"
                  v-show="procedimento.grau != null && procedimento.grau.length > 0">
                    <span><strong>Grau:</strong></span> <br>
                    <span>{{procedimento.grau}}</span>
                  </div>
                  <div class="col">
                    <span><strong>Quant:</strong></span> <br>
                    <span>{{procedimento.quantidade}}</span>
                  </div>
                  <div class="col text-right">
                    <span>
                      <b>R$ {{ formatDecimalNumber(procedimento.valor, 2, ".", ",") }}</b>
                    </span>
                  </div>
                </div>

                <div v-if="procedimento.profissionaisExecutantes.length > 0">
                  <div class="row mb-2 mt-2"
                  v-for="(profissionalExecutante, index) in procedimento.profissionaisExecutantes"
                  :key="index">
                    <div class="col-8">
                      <p class="mb-0">
                        <b>{{ FuncaoDescricao(profissionalExecutante.grau) }}:</b>
                        <br class="d-block d-md-none" />
                        {{ profissionalExecutante.nome }}
                      </p>
                    </div>
                    <div class="col-4 text-right">
                      <p class="mb-0">
                        <b>R$ {{ profissionalExecutante.valor | currency }}</b>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                </div>

              </div>
            </div>
          </template>

          <template slot="right">
            <div class="producao-procedimento-detail-actions-mobile">
              <div class="row">
                <div class="col producao-procedimento-detail-action-delete">
                  <v-btn color="error" icon large class="disable-icon-button"
                  @click.stop="excluir(idProvisao, procedimento.codigoProcedimento)"
                  :disabled="loading.status || disableAproveProvisao">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </div>
                <div class="col producao-procedimento-detail-action-ok"
                v-bind:class="{ 'producao-procedimento-detail-action-disabled--': disableAproveProvisao }">
                  <v-btn color="primary" icon large class="disable-icon-button"
                  @click.stop="efetivar(idProvisao, procedimento.codigoProcedimento)"
                  :disabled="loading.status || disableAproveProvisao">
                    <v-icon>check_circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>


            <div class="swipeout-action action-panel-right d-none">
              <div class="box-action-buttons">
                <button class="bt-action-mobile bt-red"
                  @click.stop="excluir(idProvisao, procedimento.codigoProcedimento)">
                  <div class="container-link">
                    <img src="/img/icons/shape-calendar-excluir-branco.png"
                      alt="" class="bt-icone">
                    <span>EXCLUIR</span>
                  </div>
                </button>

                <button class="bt-action-mobile bt-green"
                  @click.stop="efetivar(idProvisao, procedimento.codigoProcedimento)">
                  <div class="container-link">
                    <img src="/img/icons/shape-view-calendar-branco.png" alt=""
                      class="bt-icone">
                    <span>OK</span>
                  </div>
                </button>
              </div>
            </div>
          </template>
        </swipe-list>
      </div>
    </div>

    <loader data-cy="loader" :loading="loading.status"
    :text="loading.text" />
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash'
import { SwipeList, SwipeOut } from 'vue-swipe-actions'
import 'vue-swipe-actions/dist/vue-swipe-actions.css'

import { NumberMixin, DateMixin } from '@finx/web-repository/src/mixin/_'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'

import { APROVAR_DIS_LISTAR } from '@/store/medico/provisao/aprovar-const'
import AprovarStore from '@/store/medico/provisao/aprovar'
import FuncaoDescricao from '@/factories/ProfissionalExecutanteFuncaoDescricao'


export default {
  mixins: [NumberMixin, DateMixin],
  components: {
    SwipeList,
  },
  props: {
    procedimento: {
      type: Object,
    },
    idProvisao: {
      type: String,
      default: null,
    },
    sequencial: {
      type: Number,
      default: null,
    },
    dataRealizacao: {
      type: Date,
    },
    disableAproveProvisao: {
      type: Boolean,
    },
    usuario: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
      id: null,
      swipeList: [{
        id: 0,
      }],

      showEquipe: false,

      loading: {
        status: false,
        text: 'Carregando...',
      },
    }
  },
  methods: {
    contentClick(e) {
      this.$refs.swipe.$refs['list-item-0'][0].closeActions()
    },
    efetivar(id, sequencial) {
      this.loading.status = true

      const that = this

      ApiLegacy.Provisao.efetivarProducao(id, sequencial)
        .then((result) => {
          if (result.status === 200) AprovarStore.dispatch(APROVAR_DIS_LISTAR)

          this.$ga.event('provisao', 'aprovar', this.usuario.email, this.procedimento.quantidade)

          that.loading.status = false
        })
    },
    excluir(id, sequencial) {
      const that = this

      ApiLegacy.Provisao.excluir(id, sequencial)
        .then((result) => {
          if (result.status === 200) AprovarStore.dispatch(APROVAR_DIS_LISTAR)
        })
    },
    FuncaoDescricao(grau) {
      return FuncaoDescricao.funcao(grau)
    },
  },
}
</script>

<style lang="scss" scoped>
.disable-icon-button {
  background-color: #bdbdbd;
}

.detalhe-procedimento {
  p {
    font-size: 12px
  }
}

.theme--light.v-btn.v-btn--disabled .v-icon {
  color: #FFF !important;
}

.producao-procedimento-nome {
  font-weight: 600;
  color: #2652a3;
  font-size: 12px;
  margin: 0;
  line-height: 12px;
}

.detalhe-equipe {
  padding: 0 15px;
}

.producao-procedimento-detail {
  color: $cl-black;
  font-size: 12px;
  padding: 0 10px;

  .col {
    padding: 0 5px;
    flex-basis: auto;
    float: left;
    width: auto;
  }
}

.producao-procedimento-buttons {
  text-align: center;
  padding: 0 8px;

  @media(max-width: 767px) {
    display: none
  }

  img {
    margin: 0 auto;
    display: block;
    width: 24px
  }
}

.producao-procedimento-detail-actions-mobile {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  height: 100%;
  padding: 0 15px;

  .row,
  .col,
  .producao-procedimento-buttons {
    height: 100%;
  }

  .producao-procedimento-buttons {
    display: block;
    text-align: center;
    margin: 0 auto;
    width: 100%;
    padding: 0;
  }
}

.detalhe-procedimento-content-mobile {
  padding: 0 15px 15px
}

.producao-procedimento-detail-action-delete,
.producao-procedimento-detail-action-ok {
  min-width: 100px;

  button.v-btn {
    position: absolute;
    top: 50%;
    margin-top: -25%;
  }
}

.producao-procedimento-detail-action-delete {
  // background-color: #e53f4b
  border-right: 1px solid rgba(0, 0, 0, 0.1)
}

.producao-procedimento-detail-action-ok {
  // background-color: #03a5ed
}

.detalhe-procedimento {
  padding: 15px 15px 0;

  @media(max-width: 767px) {
    padding: 0;
  }
}

.producao-procedimento-buttons-content {
  span {
    font-weight: 600;
    font-size: 11px;
    position: relative;
    top: -3px;

    @media(max-width: 767px) {
      color: #FFF
    }
  }
}

.producao-procedimento-button-delete {
  color: #e90000
}

.producao-procedimento-button-ok {
  color: #03a5ed;
}

.producao-procedimento-button-delete,
.producao-procedimento-button-ok {
  &[disabled] {
    color: #CCC;

    img {
      filter: grayscale(100%);
      opacity: .4;
    }
  }
}

.producao-procedimento-button-delete {
  &[disabled] {
    img {
      opacity: .3;
    }
  }
}

.swipe-mobile {
  @media(min-width: 768px) {
    display: none;
  }
}

.producao-procedimento-detail-action-disabled {
  background-color: #CCC;

  img {
    filter: brightness(0) invert(1);
    opacity: 1 !important;
  }
}

</style>
